import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/credit-actions.module.scss';
import { ICredit } from 'src/types/credit';

const CreditActionsColumn: React.FunctionComponent<CellProps<ICredit>> = ({
    cell: {
        row: { original },
    },
}: CellProps<ICredit>) => {
    return (
        <div className={classNames(styles.actions)}>
            {original.status === 1 ? (
                <Link className="btn btn-info" to={Router.generate(routes.CREDIT_EDIT, { id: original.id })}>
                    <FontAwesomeIcon icon={faPencilAlt} />
                </Link>
            ) : null}
        </div>
    );
};

export default CreditActionsColumn;
